export const translations = {
  ru: {
    appTitle: 'Панель управления роботом',
    logout: 'Выйти',
    robots: 'Роботы',
    loadingRobots: 'Загрузка роботов...',
    selectedRobot: 'Выбранный робот',
    status: 'Статус',
    lastUpdate: 'Обновлено',
    drive: 'Управление',
    timetable: 'Расписание',
    logs: 'Журнал',
    other: 'Другое',
    settings: 'Настройки',
    controls: 'Управл.',
    velocity: 'Скорость',
    start: 'Старт',
    starting: 'Запуск...',
    stop: 'Стоп',
    stopping: 'Остановка...',
    reset: 'Сброс',
    resetting: 'Сброс...',
    startTimetable: 'Расписание запусков',
    load: 'Загрузить',
    loading: 'Загрузка...',
    addRow: 'Добавить строку',
    save: 'Сохранить',
    saving: 'Сохранение...',
    scheduleLoaded: 'Расписание загружено',
    scheduleSent: 'Расписание отправлено роботу',
    loadScheduleFirst: 'Сначала загрузите расписание',
    loadScheduleFromRobot: 'Загрузите расписание с робота',
    failedLoadSchedule: 'Не удалось загрузить расписание',
    failedSaveSchedule: 'Не удалось сохранить расписание',
    refresh: 'Обновить',
    loadingLogs: 'Загрузка журнала...',
    logsLoaded: 'Журнал загружен',
    failedLoadLogs: 'Не удалось загрузить журнал',
    noLogs: 'Сообщений за период хранения пока нет',
    liveLogs: 'Обновляется автоматически',
    logTime: 'Время',
    logMessage: 'Сообщение',
    lidarMap: 'Карта лидара',
    lidarDistance: 'Радиус, м',
    updateLidar: 'Обновить карту',
    updatingLidar: 'Обновление...',
    lidarUpdated: 'Карта лидара обновлена',
    failedLoadLidar: 'Не удалось загрузить карту лидара',
    noLidarMap: 'Карта лидара еще не загружена',
    showLidar: 'Показать карту',
    hideLidar: 'Скрыть карту',
    delete: 'Удалить',
    deleteScheduleRow: 'Удалить строку расписания',
    selectRobot: 'Выберите робота, чтобы увидеть данные и управление',
    selectRobotHint: 'Выберите робота из списка слева, чтобы начать',
    toggleMenu: 'Открыть меню',
    closeMenu: 'Закрыть меню',
    id: 'ID',
    ip: 'IP',
    language: 'Язык',
    loginTitle: 'Панель управления роботом',
    username: 'Логин',
    password: 'Пароль',
    login: 'Войти',
    loggingIn: 'Вход...',
    invalidCredentials: 'Неверный логин или пароль. Попробуйте еще раз.',
    selectRobotVideo: 'Выберите робота для просмотра видео',
    loadingVideo: 'Загрузка видео...',
    videoError: 'Ошибка видеопотока',
    videoActive: 'Видеопоток активен',
    reconnectingVideo: 'Переподключение видео...',
    refreshingVideo: 'Обновление видео...',
    networkRestoredVideo: 'Сеть восстановлена, подключаем видео...',
    battery: 'Батарея',
    signal: 'Сигнал',
    strong: 'Хороший',
    theme: 'Тема',
    lightTheme: 'Светлая тема',
    darkTheme: 'Тёмная тема',
    total: 'Всего',
    online: 'в сети',
    offline: 'не в сети',
    live: 'LIVE',
    connectionOk: 'Подключено',
    connectionLost: 'Отключено',
    noRobots: 'Нет роботов',
    appSubtitle: 'AGROFEED · Система пододвигания корма',
    farmName: 'Красный маяк',
    of: 'из',
    farmOnline: 'В сети',
    statusOnline: 'В сети',
    statusOffline: 'Не в сети',
    speedUnit: 'м/с',
    messagesTitle: 'Сообщения',
    noMessages: 'Новых сообщений нет',
    dbm: 'дБм',
    wasdHint: 'Клавиши WASD или стрелки — движение',
    spaceHint: 'Пробел — аварийный стоп',
    nextLaunch: 'Ближайший запуск',
    timeIn: 'через',
    hoursShort: 'ч',
    minutesShort: 'мин',
    today: 'Сегодня',
    launchesCount: 'Запусков',
    completedCount: 'Завершено',
    remainingCount: 'Осталось',
    dailyLaunches: 'Дневные запуски',
    scheduleNote: 'Изменения вступают в силу после кнопки «Сохранить»',
    noScheduleStats: 'Загрузите расписание, чтобы увидеть статистику запусков',
    logSummary: 'Сводка журнала',
    totalEntries: 'Всего записей',
    errorsCount: 'Ошибки',
    warningsCount: 'Предупреждения',
    filterLabel: 'Фильтр записей',
    filterAll: 'Все',
    filterErrors: 'Ошибки',
    filterImportant: 'Важные',
    repeatedEvents: 'Повторяющиеся события',
    downloadLog: 'Скачать журнал',
    logsAutoNote: 'Новые записи появляются автоматически',
    mapSettings: 'Настройки карты',
    radiusHint: 'Дальность отображения точек',
    legendTitle: 'Легенда карты',
    legendWalls: 'Стены и постоянные объекты',
    legendObstacles: 'Препятствия в радиусе',
    legendRobot: 'Робот и направление',
    lidarInfoNote: 'Карта строится по данным лидара. Обновите её после смены радиуса.',
    lidarRedNote: 'Красные точки — объекты ближе указанного радиуса'
  },
  en: {
    appTitle: 'Robot Control Panel',
    logout: 'Logout',
    robots: 'Robots',
    loadingRobots: 'Loading robots...',
    selectedRobot: 'Selected robot',
    status: 'Status',
    lastUpdate: 'Last update',
    drive: 'Drive',
    timetable: 'Timetable',
    logs: 'Logs',
    other: 'Other',
    settings: 'Settings',
    controls: 'Controls',
    velocity: 'Velocity',
    start: 'Start',
    starting: 'Starting...',
    stop: 'Stop',
    stopping: 'Stopping...',
    reset: 'Reset',
    resetting: 'Resetting...',
    startTimetable: 'Start Timetable',
    load: 'Load',
    loading: 'Loading...',
    addRow: 'Add Row',
    save: 'Save',
    saving: 'Saving...',
    scheduleLoaded: 'Schedule loaded',
    scheduleSent: 'Schedule sent to robot',
    loadScheduleFirst: 'Load schedule before saving',
    loadScheduleFromRobot: 'Load schedule from robot',
    failedLoadSchedule: 'Failed to load schedule',
    failedSaveSchedule: 'Failed to save schedule',
    refresh: 'Refresh',
    loadingLogs: 'Loading logs...',
    logsLoaded: 'Logs loaded',
    failedLoadLogs: 'Failed to load logs',
    noLogs: 'No messages in the retention window yet',
    liveLogs: 'Updates automatically',
    logTime: 'Time',
    logMessage: 'Message',
    lidarMap: 'Lidar Map',
    lidarDistance: 'Radius, m',
    updateLidar: 'Update Map',
    updatingLidar: 'Updating...',
    lidarUpdated: 'Lidar map updated',
    failedLoadLidar: 'Failed to load lidar map',
    noLidarMap: 'No lidar map loaded yet',
    showLidar: 'Show Map',
    hideLidar: 'Hide Map',
    delete: 'Delete',
    deleteScheduleRow: 'Delete schedule row',
    selectRobot: 'Select a robot to view details and controls',
    selectRobotHint: 'Pick a robot from the sidebar to get started',
    toggleMenu: 'Toggle menu',
    closeMenu: 'Close menu',
    id: 'ID',
    ip: 'IP',
    language: 'Language',
    loginTitle: 'Robot Control Panel',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    loggingIn: 'Logging in...',
    invalidCredentials: 'Invalid credentials. Please try again.',
    selectRobotVideo: 'Select a robot to view video',
    loadingVideo: 'Loading video...',
    videoError: 'Video stream error',
    videoActive: 'Video stream active',
    reconnectingVideo: 'Reconnecting video...',
    refreshingVideo: 'Refreshing video...',
    networkRestoredVideo: 'Network restored, reconnecting video...',
    battery: 'Battery',
    signal: 'Signal',
    strong: 'Strong',
    theme: 'Theme',
    lightTheme: 'Light theme',
    darkTheme: 'Dark theme',
    total: 'Total',
    online: 'online',
    offline: 'offline',
    live: 'LIVE',
    connectionOk: 'Connected',
    connectionLost: 'Disconnected',
    noRobots: 'No robots',
    appSubtitle: 'AGROFEED · Feed push-up system',
    farmName: 'Krasny Mayak',
    of: 'of',
    farmOnline: 'Online',
    statusOnline: 'Online',
    statusOffline: 'Offline',
    speedUnit: 'm/s',
    messagesTitle: 'Messages',
    noMessages: 'No new messages',
    dbm: 'dBm',
    wasdHint: 'WASD or arrow keys — drive',
    spaceHint: 'Space — emergency stop',
    nextLaunch: 'Next launch',
    timeIn: 'in',
    hoursShort: 'h',
    minutesShort: 'min',
    today: 'Today',
    launchesCount: 'Launches',
    completedCount: 'Completed',
    remainingCount: 'Remaining',
    dailyLaunches: 'Daily launches',
    scheduleNote: 'Changes take effect after you press "Save"',
    noScheduleStats: 'Load the schedule to see launch stats',
    logSummary: 'Log summary',
    totalEntries: 'Total entries',
    errorsCount: 'Errors',
    warningsCount: 'Warnings',
    filterLabel: 'Entry filter',
    filterAll: 'All',
    filterErrors: 'Errors',
    filterImportant: 'Important',
    repeatedEvents: 'Repeated events',
    downloadLog: 'Download log',
    logsAutoNote: 'New entries appear automatically',
    mapSettings: 'Map settings',
    radiusHint: 'Point display range',
    legendTitle: 'Map legend',
    legendWalls: 'Walls and static objects',
    legendObstacles: 'Obstacles within radius',
    legendRobot: 'Robot and heading',
    lidarInfoNote: 'The map is built from lidar data. Refresh it after changing the radius.',
    lidarRedNote: 'Red points — objects closer than the selected radius'
  }
};

export const getMessages = (language) => translations[language] || translations.ru;
